module.exports = __webpack_public_path__ + "img/StudentId+wallet.de66d169.png";